"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = update;
function clone(obj) {
    if (Array.isArray(obj)) {
        return [].concat(obj);
    }

    if (obj instanceof Object) {
        return Object.assign({}, obj);
    }

    throw "Can't rewrite scalars";
}

function get(obj, path) {
    var iteratee = clone(obj);

    while (path.length > 1) {
        var key = path.shift();

        if (!iteratee.hasOwnProperty(key)) {
            return {};
        }

        iteratee = iteratee[key];
    }

    return iteratee[path.shift()];
}

function set(obj, path, value) {
    var iteratee = clone(obj);
    var result = iteratee;

    while (path.length > 1) {
        var _key = path.shift();
        iteratee = iteratee[_key] = clone(iteratee[_key] || {});
    }

    var key = path.shift();
    iteratee[key] = value;

    return result;
}

function update(obj, path, updater) {
    if (path.length === 0) {
        return obj;
    }

    var oldValue = get(obj, clone(path));
    var newValue = updater(oldValue);

    if (newValue === oldValue) {
        // nothing was changed, return old object
        return obj;
    }

    return set(obj, clone(path), newValue);
}